<template>
  <div>

    <section class="section title-background">
      <div class="container">
        <div class="columns">
          <div class="column">
            <div class="m-2">
              <h2 class="title is-size-2">INFORME</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="container">

      <div class="columns mt-01">

        <div class="column">
          <iframe class="frame-pdf" src="/assets/pdf/INFORME-SOCIAL-Y-TESORERIA-2021-2022.pdf?v=1.1" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'InformeLegislativo',
  data () {
    return {

    }
  },
  computed: {
  },
  components: {

  },
  mounted() {

  },
  methods:{

  },
  created :function(){
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/InformeLegislativo.vue